import ToolTip from 'design-system/ToolTip';
import React, { memo } from 'react';
import { useAppSelector } from 'store/hooks';
import checkFeatureFlag from 'utils/featureFlags';
import links from 'utils/links';
const strings = {
    rollingBudgets: 'Rolling budgets',
    rollingBudgetsDescription: 'Your leftover or overspent amount from the current period rolls over to the next. This applies to both the total and category budgets but not to merchant budgets. You can reset it anytime by editing your budgets.',
    rollingBudgetsDescriptionSubcategories: 'Your leftover or overspent amount from the current period rolls over to the next. This applies to your total budget and all parent categories, but not to subcategories and merchant budgets. You can reset it anytime by editing your budgets.',
};
export const RollingBudgetsTooltip = memo(({ onModalShown, onModalHidden, offset = 3 }) => {
    const showSubcategoriesCreateFlow = useAppSelector((store) => checkFeatureFlag(store.utils.featureFlags, 'show_subcategories_create_flow'));
    return (<ToolTip small offset={offset} title={strings.rollingBudgets} learnMore onPressLearnMore={() => links.openKnownLink('rollingBudgets')} subtitle={showSubcategoriesCreateFlow
            ? strings.rollingBudgetsDescriptionSubcategories
            : strings.rollingBudgetsDescription} onModalShown={onModalShown} onModalHidden={onModalHidden}/>);
});
